import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export default function useStyledTheme() {
    var theme = useContext(ThemeContext);
    return theme || {};
}
